import React from "react";
import { Zap } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function OfficeHubCTA({
  badgeText = "Ready to Simplify Your Office?",
  title = "Everything You Need,\nOne Powerful Hub",
  desc = "From check-ins to timesheets, manage your entire office workflow with ease and precision.",
  primaryText = "Get Started Now",
  secondaryText = "Schedule Demo",
  onPrimary,
  onSecondary,
}) {
  const navigate = useNavigate();
  return (
    <section className="ctaSection">
      <div className="ctaWrap ctaFadeUp">
        {/* Badge */}
        {/* <div className="ctaBadge">
          <Zap size={18} />
          <span className="ctaBadge-text">{badgeText}</span>
        </div> */}

        {/* Title */}
        <h2 className="ctaTitle">
          {title.split("\n").map((line, i) => (
            <React.Fragment key={i}>
              {line}
              {i !== title.split("\n").length - 1 && <br />}
            </React.Fragment>
          ))}
        </h2>

        {/* Description */}
        <p className="ctaDesc">{desc}</p>

        {/* Buttons */}
        <div className="ctaBtns">
          <button
            // type="button"
            className="ctaBtn ctaPrimary"
            onClick={() => {
              window.location.href = "https://app.simplifyte.com/login";
            }}
          >
            {primaryText}
          </button>

          <button
            type="button"
            className="ctaBtn ctaSecondary"
            onClick={() => navigate("/contactsales")}
          >
            {secondaryText}
          </button>
        </div>
      </div>
    </section>
  );
}
